var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fullWidth logo center", attrs: { id: "report" } },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "constainer-fluid dataContainer " },
        [
          _c("div", { staticClass: "row justify-content-center " }, [
            _c("h1", { staticClass: "Peace center violet widthFull" }, [
              _vm._v("Prodotti Caricati")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-md-9" }),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-md-3" }, [
              _c(
                "form",
                {
                  staticClass: "form-inline d-flex mx-1 justify-content-end",
                  on: {
                    submit: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.doSearch($event)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "input-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.quickSearch,
                          expression: "quickSearch"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "search", placeholder: "Cerca" },
                      domProps: { value: _vm.quickSearch },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.quickSearch = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm._m(0)
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("vdtnet-table", {
            ref: "table",
            attrs: {
              fields: _vm.fields,
              url: _vm.url,
              opts: _vm.options,
              "select-checkbox": 0,
              "container-classname": ""
            },
            on: {
              edit: _vm.doAlertEdit,
              reloaded: _vm.doAfterReload,
              "table-creating": _vm.doCreating,
              "table-created": _vm.doCreated
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-append" }, [
      _c(
        "button",
        { staticClass: "btn btn-outline-secondary", attrs: { type: "submit" } },
        [
          _c("i", { staticClass: "mdi mdi-magnify" }),
          _vm._v(" Go\n              ")
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7191a0d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7191a0d4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/showProducts/index.vue
// module id = null
// module chunks = 